/**
 * @generated SignedSource<<87963831edea0b318d6607ca5bbc840a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnifiedConsentQuery$variables = {
  aaid: string;
};
export type UnifiedConsentQuery$data = {
  readonly unified: {
    readonly consent: {
      readonly getConsent: {
        readonly code?: string | null;
        readonly consentObj?: ReadonlyArray<{
          readonly consentKey: string;
          readonly consentStatus: string;
          readonly consenthubStatus: boolean;
          readonly uppConsentStatus: boolean;
        }>;
        readonly id?: string;
        readonly identifier?: string | null;
        readonly updatedAt?: string;
        readonly value?: string;
      } | null;
    } | null;
  } | null;
};
export type UnifiedConsentQuery = {
  response: UnifiedConsentQuery$data;
  variables: UnifiedConsentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "aaid"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedConsentObj",
      "kind": "LinkedField",
      "name": "consentObj",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consentKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consentStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consenthubStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uppConsentStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "UnifiedConsentStatus",
  "abstractKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedConsentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedConsentQuery",
            "kind": "LinkedField",
            "name": "consent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getConsent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedConsentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedConsentQuery",
            "kind": "LinkedField",
            "name": "consent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getConsent",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6bf37acf35d46e7338e8539911b151e",
    "id": null,
    "metadata": {},
    "name": "UnifiedConsentQuery",
    "operationKind": "query",
    "text": "query UnifiedConsentQuery(\n  $aaid: String!\n) {\n  unified {\n    consent {\n      getConsent(value: $aaid) {\n        __typename\n        ... on UnifiedConsentStatus {\n          id\n          consentObj {\n            consentKey\n            consentStatus\n            consenthubStatus\n            uppConsentStatus\n          }\n          updatedAt\n          value\n        }\n        ... on UnifiedQueryError {\n          code\n          identifier\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc3c54c7483965895dc32f58e8e883a7";

export default node;
